module.exports = __webpack_public_path__ + "img/teaching.1f4f8e06.svg";